module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hotline",
    class: {
      toggle: _vm.show
    }
  }, [_c('div', {
    staticClass: "hotline-wrap clear",
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "tp"
  }, [_c('i', {
    staticClass: "iconfont icon-kehufuwu"
  }), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.lang == 0 ? '客户服务热线' : 'Hotline'))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.hotline))])])]), _vm._v(" "), _c('div', {
    staticClass: "btm",
    on: {
      "click": _vm.zixun
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.lang == 0 ? '立即在线咨询' : 'Consultation'))])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      right: _vm.show
    },
    staticStyle: {
      "background": "url('static/img/left_2.png') no-repeat center center"
    },
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-05aee6af"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/hotline/hotline.vue
// module id = 61
// module chunks = 15